"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AppSettingsProvider: ()=>AppSettingsProvider,
    useAppSettings: ()=>useAppSettings
});
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _merge = /*#__PURE__*/ _interopRequireDefault(require("lodash/merge"));
const _defaults = /*#__PURE__*/ _interopRequireDefault(require("./defaults"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const AppSettingsContext = /*#__PURE__*/ _react.default.createContext({});
const cannotRouteToBoth = (whichNav, item, i)=>({
        message: `Cannot route to both "toScreen" and "toUrl" on item ${i + 1} in ${whichNav}`,
        expected: 'Either "toScreen" or "toUrl" field, not both'
    });
const noRouteFor = (whichNav, item, i)=>({
        message: `No route for item ${i + 1} in ${whichNav}`,
        expected: 'Either "toScreen" or "toUrl" field'
    });
const cannotLabelBoth = (whichNav, item, i)=>({
        message: `Cannot label using both "customLabel" and "i18n" on item ${i + 1} in ${whichNav}`,
        expected: 'Either "customLabel" or "i18n" field, not both'
    });
const noLabelFor = (whichNav, item, i)=>({
        message: `No label for item ${i + 1} in ${whichNav}`,
        expected: 'Either "customLabel" or "i18n" field'
    });
const validateNavs = (nav, section)=>{
    const doubleRoute = nav.filter((item)=>item.toScreen && item.toUrl);
    const noRoute = nav.filter((item)=>!item.toScreen && !item.toUrl);
    const doubleLabel = nav.filter((item)=>item.customLabel && item.i18n);
    const noLabel = nav.filter((item)=>!item.customLabel && !item.i18n);
    const errs = [];
    errs.push(doubleRoute.map((data, i)=>({
            section,
            data,
            ...cannotRouteToBoth(section, data, i)
        })));
    errs.push(noRoute.map((data, i)=>({
            section,
            data,
            ...noRouteFor(section, data, i)
        })));
    errs.push(doubleLabel.map((data, i)=>({
            section,
            data,
            ...cannotLabelBoth(section, data, i)
        })));
    errs.push(noLabel.map((data, i)=>({
            section,
            data,
            ...noLabelFor(section, data, i)
        })));
    return errs.flat();
};
const validateSettings = (settings)=>{
    const error = {
        code: 'Settings',
        path: '~/apps/configs/settings.ts',
        errors: []
    };
    if (settings.bottomNav) {
        error.errors = error.errors.concat(validateNavs(settings.bottomNav, 'bottomNav'));
    }
    if (settings.sideNav) {
        error.errors = error.errors.concat(validateNavs(settings.sideNav, 'sideNav'));
    }
    if (error.errors?.length) {
        throw new Error(JSON.stringify(error, null, 2));
    }
};
const AppSettingsProvider = ({ children , ..._appSettings })=>{
    const initialSettings = ()=>{
        validateSettings(_appSettings);
        return (0, _merge.default)(_defaults.default, _appSettings);
    };
    const [appSettings, save] = (0, _react.useState)(initialSettings());
    const saveSettings = (settings)=>{
        // validateSettings(settings);
        return save((0, _merge.default)(appSettings, settings));
    };
    return /*#__PURE__*/ _react.default.createElement(AppSettingsContext.Provider, {
        value: {
            ...appSettings,
            saveSettings
        }
    }, children);
};
const useAppSettings = ()=>_react.default.useContext(AppSettingsContext);
